import { ExcelImport } from './PatientExcel';

export default ExcelImport;
